import axios from "axios";
import conceptos from "../../models/conceptos/concepts";
import sueldos from "../../models/conceptos/cSueldos";
import models from "../../models/gestionTiempos/models";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getConceptos() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/conceptos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return conceptos.fromJson(item);
      })
    );
  }

  getConceptoId(conceptoid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/conceptos/${conceptoid}`, { headers })
      .then(({ data }) => data);
  }

  getLiqModelos() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/modelos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return models.fromJson(item);
      })
    );
  }

  getSueldos() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/csueldos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return sueldos.fromJson(item);
      })
    );
  }

  addConcepto(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
      licTot: data.fullDayLicense,
      horTrab: data.workHours,
      redondeaLiq: data.roundSalary,
      denegarAcceso: data.denyAccess,
    };

    if (data.liqModelos && data.liqModelos.length > 0) {
      payload.liqModelos = data.liqModelos;
    }

    if (data.cSueldos && data.cSueldos.length > 0) {
      payload.cSueldos = data.cSueldos;
    }

    return axios.post(`${url}/conceptos`, payload, { headers });
  }

  deleteConcepto(conceptoid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/conceptos/${conceptoid}`, { headers });
  }

  editConcepto(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
      licTot: data.fullDayLicense,
      horTrab: data.workHours,
      redondeaLiq: data.roundSalary,
      denegarAcceso: data.denyAccess,
    };

    if (data.liqModelos && data.liqModelos.length > 0) {
      payload.liqModelos = data.liqModelos;
    }

    return axios
      .patch(`${url}/conceptos/${data.conceptId}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  addSalarieToConcept(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      conceptoId: data.conceptoId,
      cSueldoId: Number(data.idSalarie),
      fecDesde: data.fecDesde + "T00:00:00.000Z",
    };
    if (data.fecHasta) {
      payload.fecHasta =
        moment(data.fecHasta).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.post(`${url}/conceptos/csueldos`, payload, { headers });
  }

  deleteSalarieToConcept(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/conceptos/csueldos/${data.conceptoId}&${data.cSueldoId}&${data.fecDesde}`,
      { headers }
    );
  }

  editSalarieToConcept(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      ...(data.fecDesde ? { fecDesde: data.fecDesde + "T00:00:00.000Z" } : {}),
    };
    if (data.fecHasta) {
      payload.fecHasta =
        moment(data.fecHasta).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios
      .patch(
        `${url}/conceptos/csueldos/${data.conceptId}&${
          data.oldItems.cSueldoId
        }&${data.oldItems.fecDesde + "T00:00:00.000Z"}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  addLiquidationToConcept(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      conceptoId: data.conceptoId,
      liqModeloId: data.id,
      autoriza: data.auth,
    };

    return axios.post(`${url}/conceptos/liqmodelo`, payload, { headers });
  }

  deleteLiquidationToConcept(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/conceptos/liqmodelo/${data.conceptoId}&${data.id}`,
      { headers }
    );
  }

  editLiquidationToConcept(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      autoriza: data.auth === "false" ? false : true,
    };

    return axios
      .patch(
        `${url}/conceptos/liqmodelo/${data.conceptId}&${data.liqModelos}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
}

export default service;
